import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $state, $stateParams, supportPhone) {
    var ctrl = Object.create(BaseCtrl);

    $scope.supportPhone = supportPhone;

    ctrl.init = function () {
        $scope.billingDetails = $stateParams.info;
    };

    ctrl.cancel = function () {
        if ($state.is('accounts.detail.payment.setup-autopay-confirmation')) {
            $state.transitionTo('accounts.detail.payment.index', {
                accountNumber: $stateParams.accountNumber
            });
        } else {
            $state.transitionTo($state.$current.data.actions.cancel);
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', 'config.supportPhone'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/billing/controllers/SetupAutoPayConfirmationCtrl.js
// module id = 331
// module chunks = 0